export const triggerFileDownload = (content: BlobPart, fileName = 'download.txt') => {
  if (!content) {
    console.error('No content provided for download.');
    return;
  }
  const blob = new Blob([content], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
